import { Observable } from 'rxjs';
import { $httpClient } from '@/services/httpClient';
import { DOWNLOAD_ADP_FILES, GET_ADP_CUSTOMERS, GET_ADP_FILE } from '@/types/adp-file-control.types';
import { AdpFileControlModel } from '@/models/backoffice/AdpFileControlModel';
import { AdpCustomerModel } from '@/models/backoffice/AdpCustomerModel';
import { Grid } from '@/models/Grid.model';

export default class AdpFileControlService {
  private readonly baseApi: string;
  private readonly adpApi: string;

  constructor() {
    this.baseApi = '/api/bo/';
    this.adpApi = 'adp/';
  }

  public getAdpCustomers(): Observable<any> {
    return $httpClient.get<Array<AdpCustomerModel>>(this.baseApi + this.adpApi + GET_ADP_CUSTOMERS);
  }

  public getAdpFiles(searchObject): Observable<any> {
    return $httpClient.post<Grid>(this.baseApi + this.adpApi + GET_ADP_FILE, searchObject);
  }

  public downloadAdpFiles(fileId): Observable<any> {
    return $httpClient.get(this.baseApi + this.adpApi + DOWNLOAD_ADP_FILES + '?key=' + fileId);
  }
}